import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { PhoneNumberFormat, PhoneNumberUtil, PhoneNumber } from 'google-libphonenumber';
import * as T_T from 'cryface';
import SocialShareComponent from '../../shared/SocialShare/social.share.vue';
import { RealEstatePoliceService, ERealEstateBoard } from '../../services/RealEstatePoliceService/real.estate.police.service';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';

@Component({
   components: {
      SocialShareComponent
   }
})
export default class AboutMe extends Vue {
   public title: string = 'AboutMe';

   public configs = new CommonConfig();

   public agentName = '';
   public phone = '';
   public phoneE164 = '';
   public avatarUri = '';
   public agentEmail = '';
   public agentORCode: any = null;
   public policeService = new RealEstatePoliceService();

   public boardName = '';
   public agentTitle = '';

   public police = this.policeService.claimAlpha.content;

   public userInfo: any = undefined;

   @Prop()
   public realEstateBoard: any;

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public async onUserChanged(val: any, oldVal: any) {
      this.agentName = val.value.agentName;
      this.avatarUri = T_T.simpleDetect(val.value.agentImageUrl) ? val.value.agentImageUrl : '';
      this.agentTitle = T_T.simpleDetect(val.value.agentTitle) ? val.value.agentTitle : '';
      this.boardName = T_T.simpleDetect(val.value.agentCompany) ? val.value.agentCompany : '';
      this.phoneE164 = T_T.simpleDetect(val.value.agentMobile) ? val.value.agentMobile : val.value.agentPhone;
      this.agentEmail = T_T.simpleDetect(val.value.agentEmail) ? val.value.agentEmail : '';
      this.agentORCode = T_T.simpleDetect(val.value.agentWechatQRCode) ? val.value.agentWechatQRCode : null;

      this.userInfo = T_T.simpleDetect(val.value) ? val.value : undefined;

      if (this.userInfo.userId) {
         const apiHost = this.configs.cmisapiHost;
         const fetched = await AxiosPromise.get(`${apiHost}/ur/info?userId=${this.userInfo.userId}&ltype=1`);
         if (fetched.code === 200) {
            this.agentORCode = T_T.simpleDetect(fetched.data.agentSignatureImg) ? 'data:image/jpeg;base64,' + fetched.data.agentSignatureImg : '';
         }
      }

      if (this.phoneE164) {
         const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
         const phoneNumber: PhoneNumber = phoneUtil.parseAndKeepRawInput(this.phoneE164);
         this.phone = phoneUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
      }
   }

   @Watch('$store.state.auth.storeInfo', { immediate: true, deep: true })
   public async onStoreChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val.value)) {
         if (val.value.template === ERealEstateBoard.rebgv) {
            this.police = this.policeService.claimBeta.content;
         }
      }
   }

   @Watch('realEstateBoard', { immediate: true, deep: true })
   public async onRealEstateBoardChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         console.log(val, 'realEstateBoard');
         if (val === 'rebgv') {
            this.police = this.policeService.claimBeta.content;
         } else {
            this.police = this.policeService.claimAlpha.content;
         }
      }
   }

   public onAvatarClick() {
      this.$router.push('/about-agent');
   }

   public getAffixOffsetStyle() {
      return {
         'position': 'sticky',
         'top': '10px',
      };
   }
}
